<template>
  <div class="youtaofang">
    <topTitle title="柏庭荟" :list="list" :newData="newData" :ContentStatus="ContentStatus" :remakTitle="remakTitle"></topTitle>
    <p class="top_p">
    钱湖柏庭桌游俱乐部有3个社团，分别是国际麻将社团、棋牌社团、桥牌社团。
    </p>
    <p class="top_p title" style="margin: 0">一、国际麻将社团</p>
    <p class="top_p" style="margin: 0">
    麻将是中国的国粹，许多长者们闲来无事便会来上一局。
    </p>
    <p class="top_p" style="margin: 0">
    四人开战，气氛活跃；勾心斗角，智力运转；洗牌出牌，动手动脑；有输有赢，修身养性......
    </p>
     <p class="top_p" style="margin: 0">
    柏庭国际麻将社团不失为大家切磋交流的一个良好平台。
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/zhuoyou.jpg" alt="" />
    </div>
    <p class="top_p title" style="margin: 0">二、棋牌社团</p>
    <p class="top_p" style="margin: 0">
    时而三言两语、时而七嘴八舌、时而争吵不休、时而笑声朗朗，不用多想，这便是柏庭棋牌社团了，扑克、围棋、象棋、军棋、牌九，各种棋牌类竞技在这儿轮番上阵，且来看看长者们的拿手绝活！
    </p>
    <p class="top_p title" style="margin: 0">三、桥牌社团</p>
    <p class="top_p" style="margin: 0">
    桥牌在所有扑克牌游戏中最具有科学性、知识性和趣味性。它把扑克牌游戏中的运动成份减少到最低限度，而被称为一种高雅的智力运动，倍受人们的喜欢。
    </p>
    <p class="top_p" style="margin: 0">
   来柏庭的桥牌社团，用你的逻辑推理能力，上演一场牌桌风云吧！
    </p>
    <div class="item_img">
      <img src="../../assets/image/club/zhuoyou_1.jpg" alt="" />
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
import axios from "axios";
export default {
  name: "youtaofang",
  data() {
    return {
    list: [
        {
          title: "柏庭荟简介",
          small_title: "BOTING LIVING CLUB INTRODUCTION",
          hasTitle: "柏庭荟简介",
        },
        {
          title: "运动俱乐部",
          hasTitle: "运动俱乐部",
        },
        {
          title: "文艺俱乐部",
          hasTitle: "文艺俱乐部",
        },
        {
          title: "休闲俱乐部",
          hasTitle: "休闲俱乐部",
        },
        {
          title: "健身俱乐部",
          hasTitle: "健身俱乐部",
        },
         {
          title: "桌游俱乐部",
          hasTitle: "桌游俱乐部",
        },
        {
          title: "声乐俱乐部",
          hasTitle: "声乐俱乐部",
        },
         {
          title: "书画俱乐部",
          hasTitle: "书画俱乐部",
        },
         {
          title: "外语俱乐部",
          hasTitle: "外语俱乐部",
        },
         {
          title: "园艺俱乐部",
          hasTitle: "园艺俱乐部",
        }
      ],
      newData: 5,
      list2: [
        {
          img: require("../../assets/image/party/yangsheng_1.png"),
        },
        {
          img: require("../../assets/image/party/yangsheng_2.png"),
        },
        {
          img: require("../../assets/image/party/yangsheng_3.png"),
        },
      ],
      dataContent:'',
      ContentStatus:false,
      remakTitle:'',
    };
  },
  methods: {
    getHtml(e){
       this.$router.push({
        path: "/Meeting/getlist",
        query: { majorName: e },
      });
  
    }
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {
   
  },
};
</script>
<style scoped="scoped">
.title {
  font-weight: 800 !important;
}
p{
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
}
.youtaofang {
  width: 100%;
  height: 100%;
  text-align: left;
}
.top_p {
  margin-top: 0.6625rem;
  text-align: left;
  font-size: 0.35rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 0.675rem;
  text-indent: 2em;
}
.item_bd {
  margin-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.item_bd img {
  width: 4.0125rem;
  /* height: 3.0125rem; */
  border-radius: 0.125rem;
}
.navGet{
  display: inline-block;
font-size: 0.4rem;
font-family: PingFang SC;
font-weight: 500;
text-decoration: underline;
color: #3F674B;
line-height: 54px;
text-align: left;
margin-top: 0.6rem;
cursor: pointer;
}
.small_jiantou{
  display: inline-block;
  width: 0.1rem;
height: 0.1875rem;
background-image: url('../../assets/image/left_item1.png');
background-size: 100% 100%;
}
.item_jiantou1{
  margin-left: 0.125rem;
  margin-right: 0.05rem;
}
.item_jiantou2{
  background-image: url('../../assets/image/left_item2.png');
background-size: 100% 100%;
}
.item_img {
  width: 100%;
  padding: 0.5625rem 0.3rem;
}
.item_img > img {
  width: 100%;
  height: auto;
}
</style>